export default {
  slug: "jetbrains",
  code: "JB",
  label: "JetBrains",
  hideProductName: true,
  krakenDir: "JetBrains",
  thumbnailColor: "#FC801D",
  logoFamily: "jb",
};
